import { MdAutoAwesome } from "react-icons/md";
import { useLanguage } from "context/LanguageContext";
import StatusBadge from "components/ui/StatusBadge";

const ComingSoonBanner = () => {
  const { t } = useLanguage();
  return (
    <div className="flex flex-col gap-2 rounded-2xl border border-dashed border-brand-300 bg-brand-50/60 px-5 py-4 text-sm text-ink dark:border-brand-500/40 dark:bg-brand-500/10 sm:flex-row sm:items-center sm:justify-between">
      <div className="flex items-start gap-3">
        <span className="mt-0.5 flex h-9 w-9 flex-none items-center justify-center rounded-full bg-surface text-brand-500 shadow-sm">
          <MdAutoAwesome className="h-5 w-5" />
        </span>
        <div>
          <p className="font-semibold">{t("revenue.comingSoonTitle")}</p>
          <p className="text-xs text-gray-600 dark:text-gray-300">
            {t("revenue.comingSoonDesc")}
          </p>
        </div>
      </div>
      <StatusBadge label={t("revenue.demoDataBadge")} tone="info" />
    </div>
  );
};

export default ComingSoonBanner;
